import { Google } from 'reaxl-analytics-handlers';
export default function handlePostMessage(_ref, event, options) {
  let {
    history
  } = _ref;
  const {
    origin = '',
    data
  } = event;
  try {
    if (origin.includes('autotrader.com') || origin.includes('kbb.com')) {
      const formattedData = typeof data === 'string' ? JSON.parse(data) : data || {};
      const isCsAnalyticsEvent = formattedData?.event && formattedData?.type === 'csAnalyticsEvent';
      if (isCsAnalyticsEvent) {
        const {
          type,
          googleAnalytics
        } = formattedData.event ?? {};
        if (googleAnalytics) {
          switch (type) {
            case 'click':
              {
                Google.sendClickEvent(googleAnalytics.props, options);
                break;
              }
            case 'impression':
              {
                Google.sendImpressions({
                  history
                }, googleAnalytics.props, options);
                break;
              }
            default:
          }
        }
      }
    }
  } catch (error) {
    // We expect some syntax errors because we're listing to every single message on window, so ignore SyntaxError
    if (!(error instanceof SyntaxError)) {
      // eslint-disable-next-line no-console
      console.log('csAnalyticsEvent PostMessage error', error);
    }
  }
}